import http from './http';

export function getReferencesByCourse() {
	return http.get('/admin/references/bycourse').then(resp => resp.data.data);
}
